const SATOSHIS = 100000000
const DEFAULT_UPVALUE_SATS = 10000
const DEFAULT_BOOST_SATS = 10000

const BITCOIN_UNIT = 'bitcoin'
const SATOSHI_UNIT = 'satoshi'
const USD_UNIT = 'usd'
const DEFAULT_BSV_UNIT = BITCOIN_UNIT

const SATS_BEFORE_CONFIRM = 100000000

const toSats = (bitcoin: number) => bitcoin * SATOSHIS
const toBitcoin = (sats: number): string => {
    const bitcoin = sats / SATOSHIS
    // Format to avoid scientific notation, show up to 8 decimal places
    // Remove trailing zeros
    let formatted = bitcoin.toFixed(8)
    formatted = formatted.replace(/\.?0+$/, '')

    // If it's a whole number, just return it without decimal
    // If it has no decimal point after removing trailing zeros, it was a whole number
    if (!formatted.includes('.')) {
        return formatted || '0'
    }

    return formatted
}

const format = (big: number) => {
    if (big >= 1000000) {
        const millions = Math.round(big / 100000) / 10
        let formattedSats = millions.toFixed(1).replace(/\.0$/, '') + 'M'
        return formattedSats
    } else if (big >= 1000) {
        const thousands = Math.round(big / 100) / 10
        let formattedSats = thousands.toFixed(1).replace(/\.0$/, '') + 'K'
        return formattedSats
    }
    return big.toString()
}

type BsvUnit = typeof BITCOIN_UNIT | typeof SATOSHI_UNIT | typeof USD_UNIT

/** Abbreviate a txid for compact display, e.g. 3dcc6392…c13b87a. */
function shortTxid(txid: string | null | undefined): string {
    if (!txid) return ''
    return txid.length > 14 ? `${txid.slice(0, 8)}…${txid.slice(-6)}` : txid
}

export {
    SATOSHIS,
    DEFAULT_UPVALUE_SATS,
    DEFAULT_BOOST_SATS,
    BITCOIN_UNIT,
    SATOSHI_UNIT,
    USD_UNIT,
    DEFAULT_BSV_UNIT,
    SATS_BEFORE_CONFIRM,
    toSats,
    toBitcoin,
    format,
    shortTxid,
}
export type { BsvUnit }
